<template>
  <div class="appointment_suc">
    <van-nav-bar title left-arrow @click-left="back" />
    <div class="wrap">
      <svg-icon icon-class="suc" />
      <p>预约申请提交成功</p>

      <div class="tip">
        <span>温馨提示：</span>
        <p>1、请联系被访人尽快审核您的来访申请，审核结果将通过公众号通知您；</p>
        <p>2、您也可在<a style="color: #3B86FF" @click="onRun">[个人中心-历史记录]</a>中查看预约详情。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InviteSuc',
  methods: {
    back() {
      this.$router.go(-1)
    },
    onRun() {
      this.personalInfo = JSON.parse(
        localStorage.getItem('personalInfo') || '{}'
      );
      switch (this.personalInfo.staff) {
        case false:
          this.$router.push({ name: 'history' });
          break;
        case true:
          this.$router.push({ name: 'staffHistory' });
          break;
        default:
          break;
      }
    }
  }
}
</script>

<style lang="less" scoped>
.appointment_suc {
  .svg-icon {
    font-size: 0.6rem;
    margin-bottom: 0.2rem;
  }
  .wrap {
    text-align: center;
    margin-top: 0.7rem;
    font-size: 0.14rem;
    color: #333;
    > p {
      font-size: 0.2rem;
    }
    .tip {
      text-align: left;
      margin-top: 0.2rem;
      padding: 0 0.27rem;
      line-height: 0.28rem;
      span {
        color: #f2b230;
        line-height: 0.3rem;
      }
      p {
        color: #888;
      }
    }
  }
}
</style>
